// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.cdk-drag-preview {
  z-index: 1051 !important; /* higher than Bootstrap modal (z-index 1050) */
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/app/views/view-builder/security-pop-up/security-pop-up.component.css"],"names":[],"mappings":";AACA;EACE,wBAAwB,EAAE,+CAA+C;EACzE,oBAAoB;AACtB","sourcesContent":["\r\n.cdk-drag-preview {\r\n  z-index: 1051 !important; /* higher than Bootstrap modal (z-index 1050) */\r\n  pointer-events: none;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
